import React from 'react';
import cx from 'classnames';
import { WARNING_SETTINGS_MAP } from '../../constants/EventWarningTypes';
import GoogleFontsIcon from '@shared/components/icons/GoogleFontsIcon';

/**
 * @typedef {object} WarningComponentProps
 * @property {number} [warningType]
 * @property {number} [eventId]
 * @property {boolean} [renderIconAsTitle]
 * @property {string} [customClassName]
 */

/**
 * @param {WarningComponentProps} props
 */
const WarningComponent = props => {
  const { renderIconAsTitle, eventId, warningType = 0, customClassName = '' } = props;

  const warningSettings = WARNING_SETTINGS_MAP.get(warningType);

  if (!warningSettings) {
    return null;
  }

  const { title, iconStyle, iconType, hideIconForCalendarPage } = warningSettings;
  if (hideIconForCalendarPage) {
    return null;
  }

  const containerTitle = renderIconAsTitle ? title : null;
  const placeholderText = renderIconAsTitle ? null : title;

  return (
    <div className={cx('icon-container', customClassName)} title={containerTitle}>
      <GoogleFontsIcon
        dataTestId={`warning-icon-${eventId}-${warningType}`}
        className={cx('large-warning-icon', iconStyle)}
        iconType={iconType}
      />
      {placeholderText && <p>{placeholderText}</p>}
    </div>
  );
};

export default WarningComponent;
